import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'solicitacao-operadoras-de-maquina'
})
export class SolicitacaoOperadora extends JsonApiModel {
    @Attribute() nomeOperadora: string
    @Attribute() linkSiteOperadora: string
    @Attribute() nomeUsuario: string
    @Attribute() telefoneUsuario: string
    @Attribute() emailUsuario: string
    @Attribute() observacoesUsuario: string
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/solicitacao-operadora.model.ts